import classNames from 'classnames'
import { useRouter } from 'next/router'
import styles from './CompetitionTabs.module.css'
import {
  CompetitionType,
  IAICompetitionDetail,
  getAiCompetitionResultList_marketingModule_competitionResult,
  getCompetitionNews_marketingModule_competitionNewsPo,
} from '~/graphqls/types'

export const CompetitionTabs: React.FC<{
  banner: IAICompetitionDetail
  competitionResultList: getAiCompetitionResultList_marketingModule_competitionResult[]
  competitionNews: getCompetitionNews_marketingModule_competitionNewsPo[]
  extra?: React.ReactNode
}> = ({ banner, competitionResultList, competitionNews, extra }) => {
  const router = useRouter()
  const competitionId = router.query.id

  const tabData = [
    {
      name: '参赛作品',
      path: `/ai-competition/${competitionId}`,
      visible: true,
    },
    {
      name: '活动介绍',
      path: `/ai-competition/${competitionId}/intro`,
      visible: true,
    },
    {
      name: '获奖公示',
      path: `/ai-competition/${competitionId}/announcement`,
      visible: !!banner?.award_announcement_p_c,
    },

    {
      name: '获奖作品',
      path: `/ai-competition/${competitionId}/award`,
      visible:
        !!competitionResultList?.length &&
        banner.type !== CompetitionType.DRAFT,
    },
    {
      name: '媒体报导',
      path: `/ai-competition/${competitionId}/report`,
      visible: !!competitionNews?.length,
    },
  ]

  return (
    <div className="my-10 flex justify-between items-center">
      <div className="flex">
        {tabData
          .filter(it => it.visible)
          .map(it => (
            <div
              className={classNames(styles.tab, {
                active: router.asPath.split('?')[0] === it.path,
              })}
              onClick={() => router.replace(it.path)}
              key={it.name}
            >
              {it.name}
            </div>
          ))}
      </div>
      {extra}
    </div>
  )
}
